{
  "avalancheSize.label": "Dimensione valanga",
  "avalancheSize.small": "piccole",
  "avalancheSize.medium": "medie",
  "avalancheSize.large": "grandi",
  "avalancheSize.very_large": "molto grandi",
  "avalancheSize.extreme": "estreme",
  "snowpackStability.label": "Stabilità del manto nevoso",
  "snowpackStability.good": "buona",
  "snowpackStability.fair": "discreta",
  "snowpackStability.poor": "scarsa",
  "snowpackStability.very_poor": "molto scarsa",
  "frequency.label": "Punti pericolosi",
  "frequency.none": "pochissimi",
  "frequency.few": "pochi",
  "frequency.some": "alcuni",
  "frequency.many": "molti",
  "dangerRating.label": "Grado di pericolo",
  "dangerRating.missing": "mancante",
  "dangerRating.missing.long": "Mancante",
  "dangerRating.no_snow": "privo di neve",
  "dangerRating.no_snow.long": "Privo di neve",
  "dangerRating.no_rating": "senza valutazione",
  "dangerRating.no_rating.long": "Senza Valutazione",
  "dangerRating.low": "debole",
  "dangerRating.low.long": "Grado di pericolo 1 — Debole",
  "dangerRating.low.speech": "pericolo valanghe debole, dunque grado uno",
  "dangerRating.moderate": "moderato",
  "dangerRating.moderate.long": "Grado di pericolo 2 — Moderato",
  "dangerRating.moderate.speech": "pericolo valanghe moderato, dunque grado due",
  "dangerRating.considerable": "marcato",
  "dangerRating.considerable.long": "Grado di pericolo 3 — Marcato",
  "dangerRating.considerable.speech": "pericolo valanghe marcato, dunque grado tre",
  "dangerRating.high": "forte",
  "dangerRating.high.long": "Grado di pericolo 4 — Forte",
  "dangerRating.high.speech": "pericolo valanghe forte, dunque grado quattro",
  "dangerRating.very_high": "molto forte",
  "dangerRating.very_high.long": "Grado di pericolo 5 — Molto Forte",
  "dangerRating.very_high.speech": "pericolo valanghe molto forte, dunque grado cinque",
  "avalancheType.label": "Tipo di valanga",
  "avalancheType.slab": "Valanga di neve a lastroni",
  "avalancheType.loose": "Valanga di neve a debole coesione",
  "avalancheType.glide": "Valanga di slittamento",
  "avalancheProblem.label": "Problema valanghivo",
  "avalancheProblem.coreZones.label": "Avalanche Problems with Core Zones",
  "avalancheProblem.new_snow": "Neve fresca",
  "avalancheProblem.wind_slab": "Lastrone da vento",
  "avalancheProblem.persistent_weak_layers": "Strati deboli persistenti",
  "avalancheProblem.wet_snow": "Neve bagnata",
  "avalancheProblem.gliding_snow": "Valanghe di slittamento",
  "avalancheProblem.favourable_situation": "Situazione favorevole",
  "avalancheProblem.cornices": "Cornici",
  "avalancheProblem.no_distinct_avalanche_problem": "Nessun problema valanghivo evidente",
  "avalancheProblem.new_snow.speech": "un problema di neve fresca",
  "avalancheProblem.wind_slab.speech": "un problema di lastroni da vento",
  "avalancheProblem.persistent_weak_layers.speech": "un problema di strati deboli persistenti",
  "avalancheProblem.wet_snow.speech": "un problema di neve bagnata",
  "avalancheProblem.gliding_snow.speech": "un problema di valanghe di slittamento",
  "avalancheProblem.favourable_situation.speech": "una situazione favorevole",
  "avalancheProblem.cornices.speech": "un problema di cornici",
  "avalancheProblem.no_distinct_avalanche_problem.speech": "nessun problema valanghivo evidente",
  "dangerPattern.label": "Situazione tipo",
  "dangerPattern.dp1": "st.1: strato debole persistente basale",
  "dangerPattern.dp2": "st.2: neve da slittamento",
  "dangerPattern.dp3": "st.3: pioggia su neve",
  "dangerPattern.dp4": "st.4: freddo su caldo / caldo su freddo",
  "dangerPattern.dp5": "st.5: neve dopo un lungo periodo di freddo",
  "dangerPattern.dp6": "st.6: neve a debole coesione e vento",
  "dangerPattern.dp7": "st.7: passaggio da poca a molta neve",
  "dangerPattern.dp8": "st.8: brina di superficie sepolta",
  "dangerPattern.dp9": "st.9: neve pallottolare sepolta",
  "dangerPattern.dp10": "st.10: situazione primaverile",
  "aspect.N": "Nord",
  "aspect.NE": "Nord-Est",
  "aspect.E": "Est",
  "aspect.SE": "Sud-Est",
  "aspect.S": "Sud",
  "aspect.SW": "Sud-Ovest",
  "aspect.W": "Ovest",
  "aspect.NW": "Nord-Ovest",
  "tendency.label": "Tendenza",
  "tendency.progression.label": "Development of avalanche danger",
  "tendency.decreasing": "Tendenza: pericolo valanghe in diminuzione",
  "tendency.steady": "Tendenza: pericolo valanghe stabile",
  "tendency.increasing": "Tendenza: pericolo valanghe in aumento",
  "validTimePeriod.all_day": "tutto il giorno",
  "validTimePeriod.all_day.long": "tutto il giorno",
  "validTimePeriod.earlier": "prima parte",
  "validTimePeriod.earlier.long": "nella prima parte della giornata",
  "validTimePeriod.later": "più tardi",
  "validTimePeriod.later.long": "più tardi nella giornata",
  "elevation.treeline.capitalized": "Limite del bosco",
  "elevation.treeline": "limite del bosco",
  "elevation.all": "Tutte le quote",
  "elevation.below": "Sotto i {0}",
  "elevation.above": "Sopra i {0}",
  "elevation.band": "Tra {0} e {1}",
  "synopsis.label": "Meteo",
  "snowpack.label": "Manto nevoso",
  "travelAdvisory.label": "Travel Advisory",
  "forecast.label": "Previsione valanghe"
}
